'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Detects, if babel polyfills have to be required.
 */
var browserSupportsAllFeatures = function browserSupportsAllFeatures() {
  return window.Promise && window.fetch && window.Symbol && window.Array.prototype.includes;
};

/**
 * Checks, if library is running in a browser (as opposed to node)
 */
var runningInBrowser = function runningInBrowser() {
  return typeof window !== 'undefined';
};

if (runningInBrowser() && !browserSupportsAllFeatures()) {
  console.info('[FOB-JS-CLIENT] load babel polyfill');
  require('babel-polyfill');
}

var axios = require('axios');
var templates = require('./templates');

var _require = require('./entity/entityProvider'),
    EntityProvider = _require.EntityProvider;

exports.printMsg = function () {
  console.log('This is a Javascript version of the FOB client.');
};

/**
 * This function intializes the module. It can be called like this:
 *   ```
 *   const fobclient = require('./fobclient').login(config)
 *   ```
 * @param {Object} connection - The connection object handles how to
 * store the details of the backend, i.e. url, post, username, password,
 * and also the received token.
 * @returns The module itself.
 */
module.exports.init = function (connection) {
  var loginConnection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : connection;

  module.exports.login = _login(connection, loginConnection);
  module.exports.find = require('./find')(connection);
  module.exports.entity = require('./entity');

  module.exports.genericSave = templates.genericSaveTemplate(connection);
  module.exports.genericCreate = templates.genericCreateTemplate(connection);

  module.exports.updateEntity = function (entity) {
    var route = entity.constructor.__name__();

    return templates.genericSaveTemplate(connection)(route)(entity.toPostData()).then(function (_ref) {
      var data = _ref.data;

      return new (EntityProvider(data._entityName))(data);
    });
  };

  module.exports.updaveEntity = function (entity) {
    var route = entity._entityName.split('.').splice(-1)[0].toLowerCase();

    var promises = [];
    // recursively save newly created embedded entities
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Object.values(entity)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var value = _step.value;

        var refs = value;
        if (!Array.isArray(value)) {
          refs = [value];
        }

        var _loop = function _loop(ref) {
          if ((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' && ref != null && typeof ref._entityName !== 'undefined') {
            promises.push(module.exports.updaveEntity(ref).then(function (entity) {
              // 'injecting' id and url of newly saved reference
              ref._id = entity._id;
              ref._url = entity._url;
            }));
          }
        };

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = refs[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var ref = _step2.value;

            _loop(ref);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Promise.all(promises).then(function () {
      if (entity._id != null && typeof entity._id === 'number' && entity._dirty && typeof entity._entityName !== 'undefined') {
        return templates.genericSaveTemplate(connection)(route)(entity.toPostData()).then(function (_ref2) {
          var data = _ref2.data;

          entity._dirty = false;
          return new (EntityProvider(data._entityName))(data);
        });
      } else if ((!entity._id || typeof entity._id !== 'number') && typeof entity._entityName !== 'undefined') {
        entity._id = null;
        return templates.genericCreateTemplate(connection)(route)(entity.toPostData()).then(function (_ref3) {
          var data = _ref3.data;

          entity._id = data._id;
          entity._url = data._url;
          entity._entityName = data.entityName;
          return new (EntityProvider(data._entityName))(data);
        });
      } else {
        return entity;
      }
    });
  };

  module.exports.postEntity = function (entity) {
    var route = entity.constructor.__name__();

    var promises = [];
    // recursively save newly created embedded entities
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = Object.values(entity)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var value = _step3.value;

        var refs = value;
        if (!Array.isArray(value)) {
          refs = [value];
        }

        var _loop2 = function _loop2(ref) {
          if ((typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) === 'object' && ref != null && ref._id == null) {
            promises.push(module.exports.postEntity(ref).then(function (postedRef) {
              ref._id = postedRef._id;
              ref._url = postedRef._url;
              ref._entityName = postedRef._entityName;
            }));
          }
        };

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = refs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var ref = _step4.value;

            _loop2(ref);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return Promise.all(promises).then(function () {
      return templates.genericCreateTemplate(connection)(route)(entity.toPostData()).then(function (_ref4) {
        var data = _ref4.data;

        entity._id = data._id;
        return new (EntityProvider(data._entityName))(data);
      });
    });
  };

  module.exports.deleteEntity = function (entity) {
    var route = entity.constructor.__name__();

    return templates.genericDeleteTemplate(connection)(route)(entity._id);
  };

  var initializedGenericGet = templates.genericGetTemplate(connection);
  module.exports.genericGet = function (entity) {
    return function (_id) {
      return initializedGenericGet(entity)(_id).then(function (_ref5) {
        var data = _ref5.data;

        var entityName = data._entityName;
        return new (EntityProvider(entityName))(data);
      });
    };
  };

  var initializedResolveRefs = templates.genericResolveRefsTemplate(connection);
  module.exports.genericResolveRefs = function (obj) {
    return function (ref) {
      return initializedResolveRefs(obj.constructor.__name__())(ref)(obj._id).then(function (_ref6) {
        var data = _ref6.data;

        if (Object.keys(data).includes('_embedded')) {
          var embedded = data._embedded;
          var firstKey = Object.keys(embedded)[0];
          var refObj = embedded[firstKey].map(function (λx) {
            return new (EntityProvider(λx._entityName))(λx);
          });
          obj[ref] = refObj;
          return refObj;
        } else {
          var entityName = data._entityName;
          var _refObj = new (EntityProvider(entityName))(data);
          obj[ref] = _refObj;
          return _refObj;
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            // when fetching references, 404 means there is no reference added
            return null;
          } else {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log(error.message);
        }
      });
    };
  };
};

/**
 * This methods authenticates the user provided via the config passed
 * to the init() method. After authentication, the TOKEN is stored in
 * the module and other methods can be called. This is a module internal
 * function that needs to be initialized with a connection.
 * The connection will be injected upon initializing the module and then
 * a function `login` is exported.
 * @returns {string} the token received upon login
 */
var _login = function _login(connection) {
  var loginConnection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : connection;
  return function (credentials) {
    var username = credentials ? credentials.username : loginConnection.getUsername();
    var password = credentials ? credentials.password : loginConnection.getPassword();

    return axios({
      method: 'post',
      url: '' + loginConnection.getURIPrefix(),
      data: 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      timeout: 10000
    }).then(function (_ref7) {
      var data = _ref7.data;

      var transformedData = loginConnection.getTransformator()(data);
      var token = transformedData.token;
      connection.setToken(token);
      return data;
    }).catch(function (error) {
      console.log(error);
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/index.js
// module id = N5qN
// module chunks = 0